<!--
    描述：标签汇总 --- 详细页面
    时间：2021-01-15
    Created by ws
-->
<template>
    <div class="operation-layout pd0">
        <div class="filter-box">
            <el-form label-width="150px" ref="searchRef">
                <el-row>
                    <el-col :span="8">
                        <el-form-item label="标签对象：">{{
                            currentRow.valueName
                        }}</el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="业务板块：">{{
                            currentRow.busUnitName
                        }}</el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="8">
                        <el-form-item label="平台标签数量：">{{
                            currentRow.platformCountsName
                        }}</el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="个人标签数量：">{{
                            currentRow.privateCountsName
                        }}</el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="8">
                        <el-form-item label="标签标注记录数量：">{{
                            currentRow.typeCountsName
                        }}</el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="标签标注数量：">{{
                            currentRow.objectCountsName
                        }}</el-form-item>
                    </el-col>
                    <!-- <el-col :span="8">
                        <el-button size="small" class="btn-blue fr" @click="goBack"
                            >返回</el-button
                        >
                    </el-col> -->
                </el-row>
            </el-form>
        </div>
        <div class="operation-main">
            <div class="w-table-layout w-table-page">
                <div class="w-table-content" ref="table">
                    <vxe-table
                        ref="xTable"
                        :data="tableObj.tableData"
                        highlight-current-row
                        highlight-hover-row
                        size="small"
                        align="center"
                        border
                        height="100%"
                        auto-resize
                        resizable
                        show-overflow="tooltip"
                        show-header-overflow="tooltip"
                    >
                        <vxe-table-column
                            type="seq"
                            title="序号"
                            width="55px"
                        ></vxe-table-column>
                        <vxe-table-column
                            field="sname"
                            title="标签名"
                            min-width="185px"
                        ></vxe-table-column>
                        <vxe-table-column
                            field="type"
                            title="标签主体"
                            min-width="185px"
                        >
                            <template v-slot="{ row }">
                                <div>{{ row.type === 1 ? '平台' : '个人' }}</div>
                            </template>
                        </vxe-table-column>
                        <vxe-table-column
                            field="totalCounts"
                            title="热度"
                            width="165px"
                            align="center"
                        >
                            <template v-slot:header>
                                <span
                                    >热度<el-tooltip
                                        placement="bottom-start"
                                        width="300"
                                        trigger="hover"
                                        effect="light"
                                        content="这个标签被应用的总次数(不同的用户，为同一个记录打了同一个标签，重复计算)"
                                    >
                                        <i class="el-icon-info ml5"></i> </el-tooltip
                                ></span>
                            </template>
                        </vxe-table-column>
                        <vxe-table-column
                            field="applyCounts"
                            title="应用记录数"
                            width="165px"
                            header-align="center"
                            align="right"
                        >
                            <template v-slot:header>
                                <span
                                    >应用记录数<el-tooltip
                                        placement="bottom-start"
                                        width="300"
                                        trigger="hover"
                                        effect="light"
                                        content="这个标签被应用的记录的数量(不同的用户，为同一个记录打了同一个标签，不重复计算)"
                                    >
                                        <i class="el-icon-info ml5"></i> </el-tooltip
                                ></span>
                            </template>
                        </vxe-table-column>
                        <vxe-table-column
                            field="createUser"
                            title="创建人"
                            width="165px"
                            align="center"
                        >
                        </vxe-table-column>
                        <vxe-table-column
                            field="createTime"
                            title="创建时间"
                            width="165px"
                            align="center"
                        >
                        </vxe-table-column>
                        <vxe-table-column title="操作" width="140px">
                            <template v-slot="{ row }">
                                <el-popover
                                    placement="top"
                                    width="200"
                                    v-model="row.visible"
                                    trigger="hover"
                                    :open-delay="500"
                                >
                                    <p class="tips-row">
                                        是否确认将
                                        <span class="tips-text">{{ row.sname }}</span>
                                        设置为公共标签！
                                    </p>
                                    <div class="text-center">
                                        <el-button
                                            size="mini"
                                            type="text"
                                            @click="row.visible = false"
                                            >取消</el-button
                                        >
                                        <el-button
                                            type="primary"
                                            size="mini"
                                            @click="setCommon(row)"
                                            >确定</el-button
                                        >
                                    </div>
                                    <vxe-button
                                        content="设为公共标签"
                                        slot="reference"
                                        :class="row.type === 1 ? '' : 'btn-blue'"
                                        status="primary"
                                        size="small"
                                        :disabled="row.type === 1"
                                    ></vxe-button>
                                </el-popover>
                            </template>
                        </vxe-table-column>
                    </vxe-table>
                </div>
                <div class="w-table-footer">
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="tableObj.currentPage"
                        :page-size="tableObj.pageSize"
                        :page-sizes="[10, 20, 50, 100]"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="tableObj.total"
                    >
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getDetail, setCommonTag } from "api/modules/tag_management";
export default {
    props: {
        // 所有数据
        allList: {
            type: Array,
            default: () => {
                return [];
            },
        },
    },
    data() {
        return {
            // 表格参数
            tableObj: {
                tableData: [{}],
                currentPage: 1,
                pageSize: 10,
                total: 0,
            },
            visible: false,
        };
    },
    created() {
        this.doSearch();
    },
    methods: {
        // 查询
        doSearch() {
            let params = {
                current: this.tableObj.currentPage,
                size: this.tableObj.pageSize,
                busUnit: this.queryParams.busUnit, // 业务板块码表值
                applys: this.queryParams.applys, // 标签对象码表值
            };
            getDetail(params)
                .then((res) => {
                    if (res.operationCode === 1) {
                        res.data.records.map((x) => (x.visible = false));
                        this.tableObj.tableData = res.data.records;
                        this.tableObj.total = parseInt(res.data.total);
                    }
                })
                .catch((err) => {});
        },

        // 表格 每页条数切换
        handleSizeChange(size) {
            this.tableObj.pageSize = size;
            this.doSearch();
        },

        // 表格 页码切换
        handleCurrentChange(cur) {
            this.tableObj.currentPage = cur;
            this.doSearch();
        },

        // 展示 确认弹窗
        showPopover(event) {
            let e = event.$event || window.event;
            e.stopPropagation();

            this.visible = true;
        },

        // 设置公共标签
        setCommon(row) {
            row.visible = false;
            let params = {
                applys: row.applys, // ----标签对象（码表）
                busUnit: row.busUnit, //----业务板块（码表）
                id: row.id,
                createUserid: row.createUserid, //---创建人id
                type: row.type, // ----类型  0：个人  1：平台
                sname: row.sname, // ----标签名称
                createUser: row.createUser, //---创建人名称
            };
            setCommonTag(params)
                .then((res) => {
                    if (res.operationCode === 1) {
                        this.$message.success("设置成功！");
                        // 重载页面
                        this.doSearch();
                    } else {
                        this.$message.warning(res.msg);
                    }
                })
                .catch((err) => {});
        },

        // 返回
        goBack() {
            this.$router.push({
                path: "/tag-summary",
            });
        },
    },
    computed: {
        // 路由参数
        queryParams() {
            return this.$route.query;
        },

        // 当前数据行
        currentRow() {
            let _item = this.allList.find((x) => x.id === this.queryParams.rowId);
            if (_item) {
                return _item;
            }
            return {};
        },
    },
};
</script>

<style scoped lang="less">
/deep/ .el-form-item__label {
    padding-right: 0;
}
.filter-box {
    border-bottom: none;
}
.tips-row {
    padding-bottom: 10px;
    .tips-text {
        font-weight: 700;
        font-size: 16px;
        color: #409eff;
    }
}
</style>
